<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/2idYL3/tc-custom/9781460362983.jpg?1704569473531" alt="This image is the cover for the book White Horses"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">White Horses
      </h1>
      <p class="bookDescription body article font2">
        <b>January 1813the British army is preparing to cross the Pyrenees and advance against Napoleon's army. Only one thing stands in the wayfunds. It will take two people masquerading as lovers to carry out a dangerous plan</b><br/><br/>Despite inheriting the traveling <i>Cirque Equestre</i>France's proudest equestrian traditionGabrielle Rochon has no loyalty to the emperor who destroyed her family's way of life. Independent and headstrong, she pledges to help the British army, knowing her late father would have done the same. But her mission to smuggle gold across France within the <i>cirque</i> to the Duke of Wellington's headquarters in Spain is one the British won't let her do alone.<br/><br/>Colonel Leo Branfordan arrogant, striking foreigneris ordered to play the part of her husband so that he may escort the gold without arousing enemy suspicions.<br/><br/>While Gabrielle is annoyed that she must publicly bow to his every whim, the danger of the mission binds them in a disturbingly intimate way. With French troops precariously close to uncovering their charade, it is imperative that neither of them forget their purposeor themselves.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Joan Wolf
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Harlequin
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?e46cf8a2